module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/budget_lv_mobile-9989a1e99188f2ba14a7b04fc659c459.webp";